<template>
    <div class="page">

        <div v-if="model != null">
            <van-panel class="panel-info">
                <van-cell slot="header" icon="orders-o" :title="$store.state.OrderTypeEnum.getLabel(model.type)+(model.options?model.options.isExcludeOrderedClerk?'(排除单)':'':'')">
                    <van-tag  v-if="model.status == 0" type="danger" size="medium">待接单</van-tag>
                    <van-tag v-else-if="model.status == 1" color="#ff976a" size="medium">待开始</van-tag>
                    <van-tag v-else-if="model.status == 2" type="primary" size="medium">服务中</van-tag>
                    <van-tag v-else-if="model.status == 3" type="success" size="medium">已完成</van-tag>
                    <van-tag v-else-if="model.status == -1" size="medium">已取消</van-tag>
                </van-cell>
                <van-cell class="cell-padding" size="large" center :clickable="isAuthority()"
                          :is-link="isAuthority()"
                          :to="isAuthority() ? '/kf/user/detail/'+ model.userId:null"
                          v-if="!(model.type == 'random' && (model.status == -1))&& model.userId != 0">
                <div class="user-item">
                  <div class="left align-center">
                    <div class="user_head">
                      <van-image
                          round
                          width="60px"
                          height="60px"
                          :src="model.headImgUrl">
                      </van-image>
                      <div class="avatarFrame" v-if="model.levelFrameUrl">
                        <img width="80px" height="80px" :src="model.levelFrameUrl"/>
                      </div>
                      <van-tag v-if="model.levelName" class="level" type="primary" round size="medium">{{ model.levelName }}</van-tag>
                    </div>
                    <div class="padding-left-sm">
                      <!-- id 已关注 黑名单 -->
                      <div class="left-sm-tag">
                        <van-tag plain type="primary">ID：{{ model.userId }}</van-tag>
                        <van-tag v-if="model.subscribe == 1" type="success">已关注</van-tag>
                        <van-tag v-else plain>未关注</van-tag>
                        <van-tag v-if="$hasFeature('user_violation_share') && model.userViolationSignList && model.userViolationSignList.length > 0" plain color="#91d5ff" @click.stop.prevent="showViolation = true" >
                          <a>{{ model.userViolationSignList.length }}条违规</a>
                        </van-tag>
                        <van-tag v-if="model.isBlacklist" type="default" color="black">黑名单</van-tag>
                      </div>
                      <!-- 用户昵称 1条违规 -->
                      <div>
                        <span>{{ model.userName }}</span>
                      </div>
                      <!-- 推荐人：xxx -->
                      <div v-if="$store.state.shop.id != 127 && model.distributorName" class="recommend">
                        推荐人：{{ model.distributorName }}
                      </div>
                    </div>
                  </div>
                  <div class="right">
                  </div>
                </div>
              </van-cell>
                <div class="content">
                    <!--    用户信息      -->
                    <div class="row" style="margin-top: 0" v-if="!(model.type == 'random' && (model.status == -1))">
                    </div>
                    <div class="row">
                        <span class="label">订单号</span>
                        <span class="value">{{model.no}}</span>
                    </div>
                    <div v-if="model.type != 'reward'" class="row">
                        <span class="label">订单内容</span>
                        <span class="value">
                          {{model.itemCategory != null ? model.itemCategory.name + '-' : ''}}
                          {{model.item.names.join('-')}} × {{model.num}}</span>
                      <button
                          v-clipboard="copyOrderContent"
                          class="van-button van-button--primary van-button--small"
                          style="height: 20px; line-height: 18px"
                          @error="copyCallback(false)"
                          @success="copyCallback(true)"
                      >
                        复制内容
                      </button>
                    </div>
                    <div class="row">
                        <span class="label">下单时间</span>
                        <span class="value">{{formatDate(model.createTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
                        <span v-if="model.status == 0">已等待 {{formatTimeDiff(model.createTime, new Date(), 0)}}</span>
                    </div>
                    <div v-if="model.status >= 1" class="row">
                        <span class="label">接单时间</span>
                        <span class="value">{{formatDate(model.confirmTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
                        <span v-if="model.status == 1">已等待 {{formatTimeDiff(model.confirmTime, new Date(), 1)}}</span>
                    </div>
                    <div v-if="model.status >= 2" class="row">
                        <span class="label">开始时间</span>
                        <span class="value">{{formatDate(model.startTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
                        <span v-if="model.status == 2">剩余时长 {{formatTimeDiff(new Date(), model.expectedEndTime, 2)}}</span>
                    </div>
                    <div v-if="model.status >= 3" class="row">
                        <span class="label">结束时间</span>
                        <span class="value">{{formatDate(model.endTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
                    </div>
                    <div v-if="model.status == -1" class="row">
                        <span class="label">取消时间</span>
                        <span class="value">{{formatDate(model.cancelTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
                    </div>
                  <div v-if="model.type==='reward'&& model.rewardGift" class="row">
                    <span class="label">礼物</span>
                    <span class="value">{{model.rewardGift.name}} x {{model.num}}</span>
                  </div>
                  <template v-if="model.type==='reward'&& model.blindBoxGiftList">
                    <div class="row" v-for="(item,index) in model.blindBoxGiftList" :key="index">
                      <span class="label">奖品</span>
                      <span class="value">{{ item.name }} x {{ item.num }}</span>
                    </div>
                  </template>
                    <div v-if="model.isContinued != null" class="row">
                        <span class="label">是否续单</span>
                        <span class="value">
                          <van-icon v-if="model.isContinued" name="success" tag="span" color="green" style="height: 20px;line-height: 20px;" />
                          <van-icon v-if="!model.isContinued" name="cross" tag="span" color="red" style="height: 20px;line-height: 20px;" />
                        </span>

                      <van-button v-if="isShowBtn()" @click="selectContinueApplyUnCheck(model)"
                      >{{ model.isContinued ? '续单转首单' : '首单转续单' }}
                      </van-button>

<!--                      <button v-if="($store.state.shop.id == 1 || $store.state.shop.id == 78-->
<!--                      || $store.state.shop.id == 82 || $store.state.shop.id == 125) && model.isContinued && model.status == 3" @click="updateFirst()"-->
<!--                              class="van-button van-button&#45;&#45;primary van-button&#45;&#45;small" style="height: 20px;line-height: 18px;">续单改首单</button>-->
                    </div>

                  <OrderContinuedDialog
                      :isShow="isOrderChangeShow"
                      :model="model"
                      :orderContinuedApplyData="orderContinuedApplyData"
                      :orderFOrCChange="orderFOrCChange"
                      :getOrderContinuedApplyList="getOrderContinuedApplyList"
                      @update:isShow="isOrderChangeShow = $event"
                  />

                  <div class="row" v-if="model.showClerkGroupName">
                    <span class="label">分组名称</span><span class="value">{{model.groupName}}</span>
                  </div>
                    <div class="row">
                        <span class="label">店员名称</span><span class="value">{{model.clerkName}}</span>
                    </div>
                  <div v-if="model.type == 'assigned' || model.type == 'reward'" class="row">
                        <span class="label">店员性别</span><span class="value">{{$store.state.ClerkSexEnum.getLabel(model.clerkSex)}}</span>
                    </div>
                    <div class="row">
                        <span class="label">订单金额</span><span class="value">￥{{formatPrice(model.totalAmount)}}</span>
                    </div>
                    <div v-if="model.userCoupon" class="row">
                        <span class="label">优惠金额</span>
                        <span class="value">￥{{ formatPrice(model.userCoupon.amount) }}</span>
                    </div>
                    <div class="row">
                      <span class="label">实付金额</span><span class="value">￥{{ formatPrice(model.payAmount) }}</span>
                    </div>
                  <div class="row" v-show="model.refundFeeSum">
                    <span class="label">退款金额</span>
                    <div class="value ">
                      <div class="flex align-center">
                        <span>￥{{ formatPrice(model.refundFeeSum) }}</span>
                        <van-button  color="var(--primary-color)" style="height: 24px;line-height: 24px;margin-left: 10px"
                                     @click="$router.push(`/order/refund-detail/${model.id}`)">退款记录
                        </van-button>
                      </div>
                    </div>
                  </div>
                  <template v-if="model.type==='assigned' && model.options">
                    <div class="row" v-if="model.options.clerkAddress">
                      <span class="label">店员地址</span>
                      <span class="value">{{ model.options.clerkAddress.address + model.options.clerkAddress.detailAddress }}</span>
                    </div>
                    <div class="row" v-if="model.options.userAddress">
                      <span class="label">用户地址</span>
                      <span class="value">{{ model.options.userAddress.address + model.options.userAddress.detailAddress }}</span>
                    </div>
                    <div class="row" v-if="model.options.distance">
                      <span class="label">距离</span>
                      <span class="value">{{ model.options.distance }}km</span>
                    </div>
                    <div class="row" v-if="model.options.distanceFee">
                      <span class="label">出行费</span>
                      <span class="value">{{ formatPrice(model.options.distanceFee) }}</span>
                    </div>
                  </template>
                    <div v-if="model.type == 'random' && model.options != null" class="row">
                        <span class="label">买家要求</span>
                        <span class="value">
                          <van-tag v-if="model.options.clerkSex != null && model.options.clerkSex != 0" type="danger" color="#f2826a" plain size="medium" style="margin-right: 3px;margin-bottom: 5px;">{{$store.state.ClerkSexEnum.getLabel(model.options.clerkSex)}}</van-tag>
                          <van-tag v-if="model.options.clerkSex === 0" type="danger" color="#f2826a" plain size="medium" style="margin-right: 3px;margin-bottom: 5px;">不分男女</van-tag>
                          <van-tag v-if="model.options.clerkGrade != null" type="danger" color="#f2826a" plain size="medium" style="margin-right: 3px;margin-bottom: 5px;">{{$store.state.ClerkGradeMap[model.options.clerkGrade]}}</van-tag>
                          <van-tag v-for="(item, index) in model.options.clerkTags" :key="index" plain size="medium" type="danger" color="#f2826a" style="margin-right: 3px;margin-bottom: 5px;">{{item}}</van-tag>
                        </span>
                    </div>
                    <div class="row">
                      <span class="label">店铺备注</span><span class="value">{{model.shopMemo}}</span>
                      <button class="van-button van-button--info van-button--small" style="height: 20px;line-height: 18px;"  @click="()=>{this.shopMemoDialog.show = true}">编辑</button>
                    </div>
                  <div class="row" v-if="$store.state.shop.id === 47 || $store.state.shop.id === 106">
                    <span class="label">服务需求</span><span class="value">{{model.userServiceMemo}}</span>
                  </div>

                    <div class="row">
                        <span class="label">买家备注</span><span class="value">{{model.userMemo}}</span>
                    </div>

                    <div class="row" v-if="($store.state.shop.id === 165 && model.userWechatId && $KfPermission.visibleOrderUserInfo.includes('wechat'))
                    || (model.status != -1 && model.userWechatId && $KfPermission.visibleOrderUserInfo.includes('wechat'))">
                        <span class="label">买家微信</span><span class="value">{{model.userWechatId}}</span>
                        <button class="van-button van-button--primary van-button--small" style="height: 20px;line-height: 18px;" v-clipboard="copyUserWechatId" @success="copyCallback(true)" @error="copyCallback(false)">复制微信号</button>
                    </div>
                    <div class="row" v-if="model.clerkMobile && $KfPermission.visibleOrderClerkInfo.includes('mobile')">
                      <span class="label">店员手机</span><span class="value">{{model.clerkMobile}}</span>
                    </div>
<!--                    <div class="row" v-if="model.status == -1 && model.refundReason">-->
<!--                      <span class="label">取消原因</span><span class="value">{{model.refundReason}}</span>-->
<!--                    </div>-->
                  <div v-if="model.status == -1 && model.refundList" style="display: flex">
                    <div style="min-width: 80px;color: #888">退款信息</div>
                    <div>
                      <div v-for="(item,index) in model.refundList">
                        <span v-if="item.operatorRole === 'super_admin'">退款人：超级管理员</span>
                        <span v-if="item.operatorRole === 'admin'">退款人：管理员-{{item.operatorName}}</span>
                        <span v-if="item.operatorRole === 'leader'">退款人：组长-{{item.operatorName}}</span>
                        <span v-if="item.operatorRole === 'kf'">退款人：客服-{{item.operatorName}}</span>
                        <span v-if="item.operatorRole === 'clerk'">退款人：店员-{{item.operatorName}}</span>
                        <span v-if="item.operatorRole === 'user'">退款人：用户</span>
                        <span v-if="item.operatorRole === 'system'">退款人：系统</span>
                        <span v-if="item.refundDesc" style="padding-left: 10px">原因：{{item.refundDesc}}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="model.refundPhotoUrls && model.refundPhotoUrls.length > 0" class="row">
                    <span class="label">退款截图</span>
                    <div class="screenshot">
                      <div class="imgStyle" v-for="(item,index) in model.refundPhotoUrls" :key="index" @click="refundImgClick(index)">
                        <img :src="item" class="screenshotImg">
                      </div>
                    </div>
                  </div>
                </div>
            </van-panel>
            <van-dialog v-model="shopMemoDialog.show" title="编辑店铺备注" show-cancel-button @confirm="updateShopMemo" @cancel="resetShopMemo" >
              <van-field v-model="shopMemoDialog.text" type="textarea"  />
            </van-dialog>
            <div class="commentBox" v-if="model.photoUrls">
                <div class="row">
                    <span class="label">反馈留言</span><span class="value">{{model.content == '' ? '-' : model.content}}</span>
                </div>
                <div class="row">
                    <span class="label">反馈截图</span>
                    <div class="screenshot">
                        <div class="imgStyle" v-for="(item,index) in model.photoUrls" :key="index" @click="imgClick(index)">
                            <img :src="item" class="screenshotImg">
                        </div>
                    </div>
                </div>
            </div>

            <!-- 标记订单 -->
            <template v-if="$store.state.shop.id !== 2362 && (sign.isSign || sign.kfWagesEnabled)">
                <div align="center" style="margin-bottom: 10px; padding: 0 10px;">
                    <van-button type="warning" size="large" :disabled="sign.isSign" @click="signOrder()">
                      {{ sign.isSign ? (sign.isUserSign ? '客选【' + sign.kfName + '】标记' : '已被【' + sign.kfName + '】标记') : '标记订单' }}
                    </van-button>
                </div>
                <div v-if="sign.intervalDays != null" class="text-center padding-bottom-xs">
                    该用户{{sign.intervalDays}}天前被{{sign.lastLfName}}标记
                </div>
            </template>

            <!-- 更换店员 -->
            <div align="center" v-if="model.type != 'reward'" style="margin-bottom: 10px; padding: 0 10px;">
                <van-button type="primary" size="large" @click="$refs.orderChangeClerk.show(orderId)">更换店员</van-button>
            </div>
            <!-- 重新抢单 -->
            <div align="center" style="padding: 0 10px;">
                <van-button type="info" size="large" v-if="model.type == 'random' && model.status != '-1'"
                            @click="revokeGrabOrder">重新抢单</van-button>
            </div>
            <!-- 退款 -->
            <div align="center" v-if="$KfPermission.refundableOrderStatus.includes(model.status) && model.status!==-1" style="margin-top:10px;margin-bottom: 10px; padding: 0 10px;">
              <van-button type="danger" size="large" @click="refund()">退款</van-button>
            </div>

            <!-- 重新抢单上拉菜单 -->
            <van-popup v-model="revokeGrabOrderShow" position="bottom" :overlay="true">
                <div>
                    <!-- 性别 -->
                    <van-radio-group v-if="clerkModel.clerkSex != null" v-model="clerkModel.clerkSex">
                        <van-cell-group>
                            <van-cell><span style="color: orangered">性别</span></van-cell>
                            <van-cell v-for="(item, index) in $store.state.ClerkSexEnum.list()" :title="item.label" clickable @click="clerkModel.clerkSex = item.value">
                                <van-radio :name="item.value"/>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>
                    <!-- 等级 -->
                    <van-radio-group v-if="clerkModel.clerkGrade != null" v-model="clerkModel.clerkGrade">
                        <van-cell-group>
                            <van-cell><span style="color: orangered">等级</span></van-cell>
                            <van-cell v-for="(name, key) in $store.state.ClerkGradeMap" :title="name" clickable @click="clerkModel.clerkGrade = parseInt(key);clerkModel.clerkGradeName = name;">
                                <van-radio :name="parseInt(key)" />
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>

                    <van-radio-group v-if="clerkModel.isExcludeOrderedClerk!= null"
                                   v-model="clerkModel.isExcludeOrderedClerk"
                                   direction="horizontal">
                    <van-cell><span style="color: orangered">排除用户下过单的店员</span></van-cell>
                      <van-radio :name="false" style="margin-left: 15px;">否</van-radio>
                      <van-radio :name="true">是</van-radio>
                  </van-radio-group>

                  <div class="popup-item">
                    <van-field
                        v-model="revokeGrabOrderRemark"
                        rows="2"
                        autosize
                        label="备注"
                        type="textarea"
                        maxlength="100"
                        placeholder="请输入备注"
                        show-word-limit/>
                  </div>
                    <div style="margin: 10px 0; padding: 0 10px;">
                        <van-button type="info" size="large" @click="onConfirmRevokeGrabOrder">确认</van-button>
                    </div>
                    <div style="margin-bottom: 10px; padding: 0 10px;">
                        <van-button type="default" size="large" @click="revokeGrabOrderShow = false">取消</van-button>
                    </div>
                </div>
            </van-popup>

            <van-dialog v-model="refundShow" title="退款信息" show-cancel-button :before-close="refundConfirm">
              <van-cell v-if="[1,127].includes($store.state.shop.id)"  :required="true"  title-class="van-cell__title van-field__label" >
                <!-- 使用 title 插槽来自定义标题 -->
                <template #title>
                  <span class="">退款场景</span>
                </template>
                <template #default>
                  <van-radio-group v-model="refundScene" direction="horizontal">
                    <van-radio name="clerkProblem">店员问题</van-radio>
                    <van-radio name="special" >特殊退单</van-radio>
                  </van-radio-group>
                </template>
              </van-cell>
              <van-cell v-if="[1,127].includes($store.state.shop.id) && refundScene === 'clerkProblem'"  :required="true"  title-class="van-cell__title van-field__label">
                <!-- 使用 title 插槽来自定义标题 -->
                <template #title>
                  <span class="">问题类型</span>
                </template>
                <template #default>
                  <van-radio-group v-model="problemType" >
                    <van-radio name="common">普通退单（{{$store.state.shopSetting.order.refund.common.clerkFine.orderAmount.value}}%，{{formatPrice(divide100(mul(totalAmount,$store.state.shopSetting.order.refund.common.clerkFine.orderAmount.value)))}}）</van-radio>
                    <van-radio name="complaint" style="white-space: nowrap;margin-top: 5px">
                      <span >客诉退单（{{$store.state.shopSetting.order.refund.complaint.clerkFine.orderAmount.value}}%，{{formatPrice(divide100(mul(totalAmount,$store.state.shopSetting.order.refund.complaint.clerkFine.orderAmount.value)))}}）</span>
                    </van-radio>
                  </van-radio-group>
                </template>
              </van-cell>
              <div>
                <van-field
                    v-model="refundFee"
                    required
                    :disabled="canRefundFee==0"
                    type = "number"
                    label="退款金额"
                    placeholder="请输入退款金额"
                />
                <div style="float: right;font-size: 10px;padding-top: 0" class="padding-sm">
                  <template v-if="canRefundFee > 0">
                    <span  style="color: #00BFFF;margin-right: 3px;" @click="canRefund()">全额退款</span>
                    <span v-if="msg != null" style="color: red;">{{msg}}</span>
                    <div  style="float: right">
                      <span>已退 <strong>{{sumRefundFee}}</strong> 元，</span>
                      <span>最多可退 <span style="color: red; font-size: 10px;">{{canRefundFee}}</span> 元</span>
                    </div>
                  </template>
                  <template v-else-if="canRefundFee == 0">
                    <span>订单实付金额为0，请填写退款原因</span>
                  </template>
                </div>
              </div>
              <van-field
                  v-model="refundReason"
                  required
                  rows="2"
                  autosize
                  label="退款原因"
                  type="textarea"
                  maxlength="100"
                  placeholder="请输入退款原因"
                  show-word-limit
              />
              <van-cell v-if="refundMethod === 'choose'"  :required="true"  title-class="van-cell__title van-field__label">
                <!-- 使用 title 插槽来自定义标题 -->
                <template #title>
                  <span class="">返还方式</span>
                </template>
                <template #default>
                  <van-radio-group v-model="refundPath">
                    <van-radio name="original" :disabled="payMode==='balance' || refundMethod!=='choose'">原路返还（{{$store.state.OrderPayModeEnum.valueOf(payMode).label}}）</van-radio>
                    <van-radio name="balance" :disabled="payMode==='balance' || refundMethod!=='choose'" style="margin-top: 10px">返还到余额</van-radio>
                  </van-radio-group>
                </template>
              </van-cell>
            </van-dialog>
          <!--  查看违规内容  -->
          <ViolationSelect :showViolation="showViolation" :userViolationSignList="model.userViolationSignList" :showRole="'kf'"
                           @changeShowViolation="changeShowViolation"></ViolationSelect>
          <!--  更换店员  -->
          <OrderChangeClerk ref="orderChangeClerk" @on-success="orderChangeClerkOnSuccess"/>
        </div>
    </div>
</template>

<script>
import  OrderChangeClerk from './components/order-change-clerk'
    import Vue from 'vue';
    import {
        Panel,
        Cell,
        CellGroup,
        Button,
        Tag,
        Icon,
        Toast,
        Dialog,
        Field,
        Popup,
        Picker,
        RadioGroup,
        Radio,
        ImagePreview,
        Image
    } from 'vant';
    import Decimal from 'decimal.js';
    import moment from 'moment';
    import VueClipboards from 'vue-clipboards';
    import {
      getOrder,
      revokeGrabOrder,
      signOrder,
      updateFirst,
      updateShopMemo,
      getRefundOrder,
      refund,
      orderFirstOrContinueChange,
      continuedApplyList,
    } from '@/api/kf/order'
    import ViolationSelect from '@/components/common/violation-select'
import OrderContinuedDialog from "@/components/OrderContinuedDialog";
    Vue.use(Panel)
        .use(Cell)
        .use(CellGroup)
        .use(Button)
        .use(Tag)
        .use(Icon)
        .use(Toast)
        .use(Dialog)
        .use(Field)
        .use(Popup)
        .use(Picker)
        .use(RadioGroup)
        .use(Radio)
        .use(Image)

    Vue.use(VueClipboards);

    export default {
        name: 'admin-order-detail',
        components: {
          OrderContinuedDialog,
          ViolationSelect,
          OrderChangeClerk
        },
        data () {
            return {
              showViolation:false,
              orderId: this.$route.params.id,
              model: null,
              sign: null,
              revokeGrabOrderShow: false,
              allowKfRefundOrder: false,
              allowKfRefundFinishOrder: false,
              refundFee: null,
              refundReason: null,
              refundShow: false,
              refundPath: null,
              refundMethod: null,
              refundScene: [1,127].includes(this.$store.state.shop.id)?'clerkProblem':null,
              problemType: [1,127].includes(this.$store.state.shop.id)?'common':null,
              payMode: null,
              payAmount: null,
              totalAmount: 0,
              sumRefundFee: null,
              canRefundFee: null,
              isOrderChangeShow: false,
              orderContinuedApplyData: null,
              msg: null,
              shopMemoDialog: {
                show: false,
                text: '',
              },
              clerkModel:{
                  clerkSex: null,
                  clerkGrade: null,
                  clerkTags: null,
                  clerkGradeName: null,
                  isExcludeOrderedClerk: null,
              },
              options: {
                  clerkSex: Number,
                  clerkGrade: Number,
                  clerkGradeName: null,
                  clerkTags: null,
                  isExcludeOrderedClerk: null
              },
              revokeGrabOrderRemark:null,
          }
        },
        computed: {
            copyUserWechatId() {
                if (this.model) {
                    return this.model.userWechatId;
                }
                return null;
            },
          copyOrderContent() {
            if (this.model) {
              return (this.model.itemCategory != null ? this.model.itemCategory.name + "-" : "") + (this.model.item.names.join("-") + "x" + this.model.num)
            }
            return null;
          }
        },
        methods: {
          orderChangeClerkOnSuccess(){
            this.loadData()
          },
          //判断权限
          isAuthority(){
            return this.$KfAccess.includes('user-manage')
          },
          changeShowViolation(val){
            this.showViolation = val
          },
          canRefund(){
            this.refundFee = this.canRefundFee
          },
          refund(){
            // 店铺6判断订单创建时间 createTime  和当前时间超过48小时直接提示不能退款
            // 取完成时间
            if (this.$store.state.shop.id == 6 && this.model.endTime) {
              const end48Time = moment(this.model.endTime).add(48, 'hours').valueOf()
              const nowTime = new Date().getTime()
              if (end48Time < nowTime) {
                Toast.fail("48小时已过，无法退款")
                return
              }
            }
            /*获取到退款订单的详情*/
            getRefundOrder(this.model.id).then((res)=>{
              this.msg = null
              this.canRefundFee = null
              this.payAmount = null
              const data = res.data
              if (data.code == 0) {
                this.totalAmount = data.data.totalAmount
                this.payAmount = Decimal.div(data.data.payAmount, 100).toNumber().toFixed(2)
                this.sumRefundFee = Decimal.div(data.data.sumRefundFee, 100).toNumber().toFixed(2)
                this.canRefundFee = Decimal.sub(this.payAmount, this.sumRefundFee).toNumber().toFixed(2)
                this.payMode = data.data.payMode
                this.refundMethod = data.data.refundMethod
                if(this.payMode === 'balance'){
                  this.refundPath = 'balance'
                }else if(this.refundMethod === 'choose'){
                  this.refundPath = 'original'
                }else{
                  this.refundPath = this.refundMethod
                }
                if(this.canRefundFee==0){
                  this.refundFee = 0;
                }
                this.refundShow = true
              } else {
                Toast.fail(data.msg)
                this.msg = data.msg
              }
            })
          },
          refundConfirm(action, done) {
            if (action == 'confirm') {
              if (this.refundReason == null || this.refundReason == '') {
                Toast.fail("请输入退款原因")
                done(false)
                return
              }
              if (this.refundFee < 0) {
                Toast.fail("退款金额不能小于0")
                done(false)
                return
              }
              if (Number(this.refundFee) > Number(this.canRefundFee)) {
                Toast.fail("退款金额最多" + this.canRefundFee)
                done(false)
                return
              }
              // 弹出框
              Dialog.confirm({
                title: '确认要申请退款吗？',
              }).then(() => {
                Toast.clear(true)
                Toast.loading()
                // 退款
                refund(
                    this.model.id,
                    Decimal.mul(this.refundFee, 100).toNumber(),
                    this.refundReason,
                    this.refundPath,
                    this.refundScene,
                    this.problemType).then((res) => {
                  Toast.clear()
                  const data = res.data
                  if (data.code == 0) {
                    this.loadData()
                    Toast.success('申请退款成功')
                    done()
                  } else {
                    Toast.fail(data.msg)
                    done()
                  }
                })
                // 关闭上拉菜单
                this.refundShow = false
              }).catch(() => {
                done()
                return
              })
            }else {
              done()
              return
            }
          },
          updateShopMemo(){
            Toast.loading({
              mask: true,
              message: '加载中...'
            })
            updateShopMemo(this.model.id,this.shopMemoDialog.text).then((res)=>{
              Toast.clear()
              const data = res.data
              if (data.code == 0) {
                Toast.success('编辑成功')
                this.loadData()
              } else {
                Dialog.alert({
                  title: '编辑失败',
                  message: data.msg
                })
              }
            })
          },
          resetShopMemo(){
            this.shopMemoDialog.text = this.model.shopMemo;
          },
          // 格式化时间差
          formatTimeDiff(start, end, status) {
            start = moment(start)
            end = moment(end)
            const diffSeconds = end.diff(start, 'seconds')
            if (status === 2 && diffSeconds < 1) {
              return '即将完成'
            }
            if (diffSeconds < 60) {
              return `${diffSeconds}秒`
            }
            const diffMinutes = end.diff(start, 'minutes')
            if (diffMinutes < 60) {
              return `${diffMinutes}分钟`
            }
            const diffHours = end.diff(start, 'hours')
            if (diffHours < 24) {
              return `${diffHours}小时`
            }
            const diffDays = end.diff(start, 'days')
            return `${diffDays}天`
          },
            copyCallback(success) {
                if (success) {
                    Toast('复制成功');
                } else {
                    Toast('复制失败，请长按文本复制');
                }
            },

          /** 续单改首单 */
          updateFirst(){
            Toast.loading({
              mask: true,
              message: '加载中...'
            })
            updateFirst(this.model.id).then(res => {
              Toast.clear()
              const data = res.data
              if (data.code == 0) {
                this.loadData()
                Toast.success('修改成功')
              } else {
                Dialog.alert({
                  title: '修改失败',
                  message: data.msg
                })
              }
            })
          },

            /** ----------------------------------- 标记订单start ----------------------------------- */
            signOrder() {
                Toast.loading({
                    mask: true,
                    message: '加载中...'
                })
                signOrder(this.model.id).then(res => {
                    Toast.clear()
                    const data = res.data
                    if (data.code == 0) {
                        Toast.success('标记成功')
                        this.loadData()
                    } else {
                        Dialog.alert({
                            title: '标记失败',
                            message: data.msg
                        })
                    }
                })
            },
            /** ----------------------------------- 标记订单end ----------------------------------- */


            /** ----------------------------------- 重新抢单start ----------------------------------- */
            revokeGrabOrder() {
                // 获取订单
                getOrder(
                    this.model.id
                ).then(res => {
                    const data = res.data
                    if (data.code == 0) {
                        this.revokeGrabOrderShow = true
                        const options = data.order.options
                        if (options != null) {
                            this.options = options
                            // 性别
                            const clerkSex = options.clerkSex
                            // 等级
                            const clerkGrade = options.clerkGrade
                            // 随机单是否排除下单店员
                            const isExcludeOrderedClerk = options.isExcludeOrderedClerk
                            if (clerkSex != null) {
                                this.clerkModel.clerkSex = clerkSex
                            }
                            if (clerkGrade != null) {
                                this.clerkModel.clerkGrade = clerkGrade
                            }
                            if (isExcludeOrderedClerk != null) {
                                this.clerkModel.isExcludeOrderedClerk = isExcludeOrderedClerk
                            }
                        }
                    } else {
                        this.revokeGrabOrderShow = false
                        Dialog.alert({
                            title: '加载失败',
                            message: data.msg
                        })
                    }
                })
            },
            /** 确认重新抢单 */
            onConfirmRevokeGrabOrder() {
                // 弹出框
                Dialog.confirm({
                    title: '提示',
                    message: '确认重新发起抢单吗？'
                }).then(() => {
                    Toast.loading({
                        mask: true,
                        message: '加载中...'
                    })
                    if(this.clerkModel.clerkSex != null){
                      this.options.clerkSex = Number(this.clerkModel.clerkSex)
                    }
                    if(this.clerkModel.clerkGrade != null){
                      this.options.clerkGrade = Number(this.clerkModel.clerkGrade)
                    }
                    if(this.clerkModel.isExcludeOrderedClerk != null){
                      this.options.isExcludeOrderedClerk = this.clerkModel.isExcludeOrderedClerk
                    }
                    if(this.clerkModel.clerkGradeName != null){
                      this.options.clerkGradeName = this.clerkModel.clerkGradeName
                    }
                    // 重新抢单
                    revokeGrabOrder(
                        this.model.id,
                        JSON.stringify(this.options),
                        this.revokeGrabOrderRemark).then(res => {
                        Toast.clear()
                        const data = res.data
                        if (data.code == 0) {
                          this.loadData()
                          Toast.success('重新发起抢单成功')
                        } else {
                          Toast.fail(data.msg)
                        }
                    })
                    // 关闭上拉菜单
                    this.revokeGrabOrderShow = false
                }).catch(() => {})
            },
            /** ----------------------------------- 重新抢单end ----------------------------------- */
            formatDate(date, format) {
                if (!date) {
                    return '';
                }
                if (!format) {
                    format = 'YYYY-MM-DD'
                }
                return moment(date).format(format);
            },
            formatPrice(price) {
                if (price != null) {
                    return Decimal.div(price, 100).toString()
                }
                return ''
            },
            loadData() {
                Toast.loading({
                    mask: true,
                    message: '加载中...'
                })
                // 设置时间范围为48小时
                // const end = new Date()
                // const start = new Date()
                // start.setTime(start.getTime() - 3600 * 24 * 7 * 1000)
                getOrder(
                    this.orderId).then(res => {
                    Toast.clear()
                    const data = res.data;
                    if (data.code == 0) {
                        this.model = data.order;
                        this.shopMemoDialog.text = this.model.shopMemo;
                        this.sign = data.sign;
                        this.allowKfRefundOrder = data.allowKfRefundOrder
                        this.allowKfRefundFinishOrder = data.allowKfRefundFinishOrder
                      this.continueApplyId = data.continueApplyId;
                      this.changeFlag = data.changeFlag;
                    } else {
                        Dialog.alert({
                            title: '加载失败',
                            message: data.msg
                        })
                    }
                })
            },
          refundImgClick(i){
            ImagePreview({
              images: this.model.refundPhotoUrls,
              startPosition: i,
            })
          },
            imgClick(i){
                ImagePreview({
                    images: this.model.photoUrls,
                    startPosition: i,
                })
            },
          selectContinueApplyUnCheck(order) {
              if(!this.model.isContinued) {
                this.getOrderContinuedApplyList(order.no)
                    .then(res => {
                      const data = res.data
                      if (data.code === 0) {
                        if (data.list.length > 0) {
                          this.orderContinuedApplyData = data.list[0];
                        }
                      }

                    })
                    .catch(error => {
                      console.error(error);
                    });
              }
            this.isOrderChangeShow = true;
          },
          getOrderContinuedApplyList(orderNo) {
            return continuedApplyList(
                0,
                orderNo,
                1,
                1
            );
          },
          handleclickImg(photoUrls, index) {
            ImagePreview({
              images: photoUrls,
              startPosition: index,
            });
          },
          orderFOrCChange(id,type){
            const applyId = this.orderContinuedApplyData? this.orderContinuedApplyData.id:null ;
            Toast.loading({
              mask: true,
              message: '正在请求中...'
            })
            orderFirstOrContinueChange(id,type,applyId).then(res => {
              const data = res.data
              Toast.clear(true)
              // Toast.loading()
              this.showModal = false;
              if (data.code === 0) {
                this.loadData()
                Toast.success('操作成功')
              }else{
                Toast.fail(data.msg)
              }
              this.isOrderChangeShow = false;
            })
          },
          isShowBtn(){

            return (!this.changeFlag) && this.$KfPermission.continuedOrderCheck && (this.model.status === 3 || this.model.status === 2);
          }

        },
        mounted() {
          this.loadData()
        },
        updated() {
          // 统一替换标签
          this.$replaceLabel(document.body, this.$store.state.label, true)
        }
    }
</script>

<style lang="less" scoped>

    .page {
        padding-bottom: 100px;

        .panel-info {
            margin-top: 10px;
          .cell-padding {
            padding: 5px 15px 10px;
            .user-item {
              display: flex;
              align-items: center;
              .userMemo {
                color: #999;
              }
              .left {
                flex: 1;
                display: flex;
                .service-info {
                  color: #333;
                }
                .created {
                  color: #555;
                  margin-bottom: 5px;
                }
                .user_head {
                  position: relative;
                  padding: 10px;
                  .avatarFrame {
                    position: absolute;
                    top: 0;
                    left: 0;
                  }
                  .level {
                    position: absolute;
                    left: 50%;
                    height: 10px;
                    font-size: 10px;
                    white-space: nowrap;
                    bottom: 0px;
                    transform: translateX(-50%);
                  }
                }
                .padding-left-sm div span{
                  margin-right: 4px;
                }
                .recommend{
                  height: 20px;
                  line-height: 20px;
                  font-size: 12px;
                  color: #999999;
                }
              }
              .right {
                text-align: right;
                min-width: 30px;
                .total-amount {
                  color: #333;
                }
              }
            }
          }

            .content {
                font-size: 14px;
                padding: 0 15px 10px;
            }
        }
        .recommend{
            padding-top: 3px;
            font-size: 12px;
            color: #999999;
        }
        .id-box{
            padding-bottom: 5px;
        }
        .row {
            display: flex;
            color: #333;
            margin: 10px 0;
            align-items: center;
        }
        .label {
            width: 80px;
            color: #888;
        }

        .value {
            flex: 1;
        }
        .commentBox{
            width: 100%;
            background: #fff;
            padding: 15px;
            margin: 20px 0;
            box-sizing: border-box;
        }
        .imgStyle{
            margin-left: 10px;
            flex: 0 0 15%;
            height: 0;
            padding-bottom: 15%;
            overflow: hidden;
            position: relative;
        }
        .screenshot{
            width: 100%;
            display: flex;
            align-content: flex-start;
            flex-flow: row wrap;
        }
        .screenshotImg{
            width: 100%;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }

    /deep/.van-field__label{
      margin-right: 0;
    }
</style>
